import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"
import {GroupBase} from "react-select";
import {IRuleInputOption} from "../components/rule/AsyncRuleInputSelection";
import {IRuleMarkups, IRuleObj, IRuleUnitOption} from "../store/entities/rules/Rule"
import {IExampleValue} from "../store/entities/rules/RuleInput";

export interface RuleSave {
    ozon_attribute_id: number | undefined
    ozon_category_id: number | undefined
    output_type: string
    input_type: string
    input_name: string
    input_unit?: string
    markups?: IRuleMarkups[]
}

export interface RuleDelete {
    ozon_category_id?: number
    output_type: string
    ozon_attribute_id?: number
}

export interface IGroupRule {
    name: string
    rules: IRuleObj[]
}

export interface ISavedRule {
    id: string
    input_name: string | null
    input_title: string | null
    input_type: string | null
    input_unit_option: IRuleUnitOption | null
    output_type: string | null
    output_unit: string | null
    ozon_attribute_id: string | null
    ozon_category_id: string | null
}

export default class ProductRulesApi {
    public static saveValueOutput(ruleSave: RuleSave): AxiosPromise<ActionAnswer<IRuleObj | null>> {
        return RequestHelper.send("post", "productRules", ruleSave)
    }

    public static deleteRule(ruleDelete: RuleDelete): AxiosPromise<ActionAnswer<IRuleObj | null>> {
        return RequestHelper.send("delete", "productRules", ruleDelete)
    }

    public static getGeneralOutput(): AxiosPromise<ActionAnswer<IGroupRule[]>> {
        return RequestHelper.send("get", "productRules&action=generalOutputs")
    }

    public static getCategoryOutputs(ozon_category_id: number): AxiosPromise<ActionAnswer<IGroupRule>> {
        return RequestHelper.send("get", "productRules&action=categoryOutputs", {ozon_category_id})
    }

    public static getValidInputs(data: {
        query?: string, output_type: string, ozon_category_id?: number, ozon_attribute_id?: number
    }): AxiosPromise<ActionAnswer<GroupBase<IRuleInputOption>[]>> {
        return RequestHelper.send("get", "productRules&action=getOutputValidTypes", data)
    }

    static getExample(rule: RuleDelete): AxiosPromise<ActionAnswer<IExampleValue | null>> {
        return RequestHelper.send("get", "productRules&action=getExampleValue", rule)
    }

    public static saveAll(rules: RuleSave[]): AxiosPromise<ActionAnswer<IGroupRule[] | null>> {
        return RequestHelper.send("post", "productRules&action=saveAll", {'rules': rules})
    }
}